export default __webpack_public_path__ + "static/media/Malefactor's Claymore.9bde90d8.jpg";